import { FC } from 'react';
import { IQueueReport } from '../../models/reports.internal';
import { nameof } from '../../utils/stringUtils';
import useGetQueueReports from '../../shared/hooks/useGetQueueReports';
import ReportsList, { SortOptions } from '../../components/shared/ReportList';
import QueueReport from './QueueReport';

const sortOptions: SortOptions<IQueueReport> = {
  'Service Level': 'slaRatio',
  'Current LWT': { selector: (qr) => qr.lwtStart ? (qr.lwtStart * -1) : null },
  'Waiting': { selector: (qr) => qr.conversationsWaiting.length },
  'Connected': { selector: (qr) => qr.conversationsConnected.length },
  'Completed': { selector: (qr) => Math.max(0, qr.acceptedCount - qr.conversationsConnected.length) },
  'Abandoned': 'abandonedCount',
};

const QueueReportsList: FC = () => (
  <ReportsList
    layout="list"
    reportData={useGetQueueReports()}
    reportComponent={QueueReport}
    sortOptions={sortOptions}
    itemsName="queues"
  />
);

QueueReportsList.displayName = nameof({ QueueReportsList });
export default QueueReportsList;